export const SET_LOCAL_STORAGE = "SET_LOCAL_STORAGE";
export const GET_LOCAL_STORAGE = "GET_LOCAL_STORAGE";
